export function summaryTransitYBIValidate(res){
    var result = true;

    result = validateOjects(res.data);

    return result;
}

function validateOjects(data) {
    return (typeof data === 'object'
        && typeof data.month === 'number'
        && Array.isArray(data.days_columns) && data.days_columns.length == 9
        && typeof data.business_days_elapsed === 'number'
        && Array.isArray(data.rows)
    )
}